import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Image,
  Button,
  Badge,
  Carousel,
} from "react-bootstrap";
import BannerImg from "../images/banimg.jpg";
import AboutImg from "../images/aboutimg.jpg";
import ArrowRight from "../images/arrowr.svg";
import Feature1 from "../images/feature1.svg";
import Feature2 from "../images/feature2.svg";
import Feature3 from "../images/feature3.svg";
import Card from "react-bootstrap/Card";
import PlanIcon1 from "../images/planicon1.svg";
import PlanIcon2 from "../images/planicon2.svg";
import PlanIcon3 from "../images/planicon3.svg";
import PlanIcon4 from "../images/planicon4.svg";
import { AiOutlineArrowRight } from "react-icons/ai";
import { Link } from "react-router-dom";
import OurPartners from "../customcomponents/OurPartners";
import TradeImgNew1 from "../images/slidernew1.jpg";
import TradeImgNew2 from "../images/slidernew2.jpg";
import TradeImgNew3 from "../images/slidernew3.jpg";
import TradeImg1 from "../images/slide1.PNG";
import TradeImg2 from "../images/slide2.PNG";
import TradeImg3 from "../images/slide3.jpg";
import TradeImg4 from "../images/slide4.jpg";
import TradeImg5 from "../images/slide5.PNG";
import TradeImg6 from "../images/slide6.PNG";
import TradeImg7 from "../images/slide7.PNG";
import TradeImg8 from "../images/slide8.PNG";
import TradeImg9 from "../images/slide9.PNG";
import TradeImg10 from "../images/slide10.PNG";
import RobotSvg from "../images/robot.svg";
import * as API from "../../services/env";
import { useAppContext } from "./AppContext";

const ImageData = [
  {
    id: 1,
    image: TradeImgNew1,
  },
  {
    id: 2,
    image: TradeImgNew2,
  },
  {
    id: 3,
    image: TradeImgNew3,
  },
  {
    id: 4,
    image: TradeImg1,
  },
  {
    id: 5,
    image: TradeImg3,
  },
  {
    id: 6,
    image: TradeImg4,
  },
  {
    id: 7,
    image: TradeImg5,
  },
  {
    id: 8,
    image: TradeImg6,
  },
  {
    id: 9,
    image: TradeImg7,
  },
  {
    id: 10,
    image: TradeImg8,
  },
  {
    id: 11,
    image: TradeImg9,
  },
  {
    id: 12,
    image: TradeImg10,
  },
  {
    id: 13,
    image: TradeImg2,
  },
];

function Home() {
  const [index, setIndex] = useState(0);
  const [checkuser, setcheckuser] = useState("monthly");

const { setAppData } = useAppContext();

const [paymentData, setpaymentData] = useState([]);
console.log("🚀 ~ Home ~ paymentData:", paymentData)

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
  const handleGetStartedClick = (prize, name, interval, product) => {
   
    
    let dataToPass = {
      fromDashboard: true,
      prize: prize, // Default value assuming prize is a string
      name: name,
      interval: interval,
      product: product,
    };

    setAppData(dataToPass);
  };
    const handleGetStartedClick2 = () => {
      const dataToPass = {
        fromDashboard: true,
        prize: "99",
      };
      paymentData.map((item, index) => {
        if (item.productDetails.name === "Premium") {
          dataToPass.prize = (item.unit_amount / 100).toString(); // Assuming unit_amount is in cents
        }
      });
      setAppData(dataToPass);
    };
  
    const getPaymentDetail = async (index) => {
      await fetch(`${API.BASE_URL}getPaymnetDetail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({}),
      })
        .then((response) => response.json())
        .then(async (res) => {
          if (res.status == true) {
            setpaymentData(res.activePricesWithDetails);
          }
        })
        .catch((error) => {});
    };
  
    useEffect(() => {
      getPaymentDetail();
    }, []);
  // const
useEffect(()=>{
  localStorage.clear()
},[])




  return (
    <>
      <section className="py-3 banner_sec">
        <Container fluid className="widthSmall">
          <Row className="align-items-center text-lg-start text-center ">
            <Col lg={6} md={12} className="position-relative">
              <h1>
                Manage Trade Compliance
                <br />
                Due Diligence easily with <span>ACCEL</span>
              </h1>

              <h4>Integrated Trade Compliance Risk Management</h4>
              <ul>
                <li>Conduct Restricted Party Sanctions Screening, </li>
                <li>HS Code Sanctions Search, </li>
                <li>Dual Use Export Control, </li>
                <li>Restricted Country Control, </li>
                <li>Precursor Chemicals and</li>
                <li>Dangerous Goods Hazchem Class </li>
              </ul>
              <h5>
                All using <span>ACCEL</span> software
              </h5>

              <Button>Get started</Button>

              <Image src={RobotSvg} className="img-fluid robotCss" alt="" />
            </Col>
            <Col lg={6} md={12}>
              <Image src={BannerImg} className="img-fluid" alt="" />
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-5 slider_new">
        <Carousel
          indicators={false}
          activeIndex={index}
          onSelect={handleSelect}
        >
          {ImageData.map((item, index) => {
            return (
              <Carousel.Item key={index}>
                <div className="imgAfter">
                  <Image src={item.image} alt="" className="img-fluid bigImg" />
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel>
      </section>

      <section className="py-5 aboutlanding_sec">
        <Container fluid className="widthSmall">
          <Row className="text-center">
            <Col lg={12} md={12}>
              <h2 className="light_heading">What We Do</h2>
              <h2>We help you grow your business</h2>
              <p>
                Import & export regulatory management software that enables you
                to schedule, plan, analyze and manage everyday screenings
              </p>
              <Image src={AboutImg} alt="" className="img-fluid" />
              <Button>
                Join Now <Image src={ArrowRight} alt="" />
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pt-3 pb-5 featureland_sec">
        <Container fluid className="widthSmall">
          <h2 className="light_heading text-center">Features</h2>
          <Row className="text-center">
            <Col lg={4} md={4}>
              <Image src={Feature1} alt="" />
              <h3>A Complete end to end trade compliance screenings
              </h3>
              {/* <p>Lorem Ipsum is simply dummy text of the printing and </p> */}
            </Col>
            <Col lg={4} md={4}>
              <Image src={Feature2} alt="" />
              <h3>Flexible Pricing Plans
              </h3>
              {/* <p>Lorem Ipsum is simply dummy text of the printing and </p> */}
            </Col>
            <Col lg={4} md={4}>
              <Image src={Feature3} alt="" />
              <h3>Easy Management
              </h3>
              {/* <p>Lorem Ipsum is simply dummy text of the printing and </p> */}
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pt-3 pb-5 howitwork_sec">
        <Container fluid className="widthSmall">
          <h2 className="light_heading text-center">How It works</h2>
          <Row className="text-center justify-content-between">
            <Col lg={2} md={6}>
              <svg width="250" height="241" viewBox="0 0 250 241" fill="none">
                <circle
                  cx="129.5"
                  cy="120.5"
                  r="118.5"
                  fill="#FEFDFD"
                  stroke="#056AEC"
                  stroke-width="3"
                />
                <circle cx="129.5" cy="120.5" r="104" fill="#F7CE46" />
                <g filter="url(#filter0_d_318_1894)">
                  <circle cx="129.5" cy="120.5" r="76" fill="#FEFDFD" />
                </g>
                <circle
                  cx="11"
                  cy="120"
                  r="9"
                  fill="#FEFDFD"
                  stroke="#056AEC"
                  stroke-width="3"
                />
                <path
                  d="M121.917 125.44C119.072 125.44 116.637 124.78 114.613 123.46C112.589 122.111 111.02 120.248 109.905 117.872C108.82 115.467 108.277 112.68 108.277 109.512C108.277 106.373 108.82 103.601 109.905 101.196C111.02 98.7905 112.589 96.9279 114.613 95.6079C116.637 94.2585 119.072 93.5839 121.917 93.5839C124.762 93.5839 127.197 94.2585 129.221 95.6079C131.245 96.9279 132.8 98.7905 133.885 101.196C135 103.601 135.557 106.373 135.557 109.512C135.557 112.68 135 115.467 133.885 117.872C132.8 120.248 131.245 122.111 129.221 123.46C127.197 124.78 124.762 125.44 121.917 125.44ZM121.917 120.38C124.234 120.38 126.126 119.412 127.593 117.476C129.06 115.54 129.793 112.885 129.793 109.512C129.793 106.139 129.06 103.484 127.593 101.548C126.126 99.6119 124.234 98.6439 121.917 98.6439C119.57 98.6439 117.664 99.6119 116.197 101.548C114.76 103.484 114.041 106.139 114.041 109.512C114.041 112.885 114.76 115.54 116.197 117.476C117.664 119.412 119.57 120.38 121.917 120.38ZM143.871 124.912V100.536L138.811 101.724V97.4119L146.247 94.1119H149.723V124.912H143.871Z"
                  fill="#222528"
                />
                <path
                  d="M112.395 147.152C111.369 147.152 110.469 146.972 109.695 146.612C108.922 146.252 108.315 145.739 107.875 145.072C107.449 144.405 107.229 143.612 107.215 142.692H109.455C109.469 143.439 109.729 144.072 110.235 144.592C110.742 145.112 111.455 145.372 112.375 145.372C113.189 145.372 113.822 145.179 114.275 144.792C114.742 144.392 114.975 143.885 114.975 143.272C114.975 142.779 114.862 142.379 114.635 142.072C114.422 141.765 114.122 141.512 113.735 141.312C113.362 141.112 112.929 140.932 112.435 140.772C111.942 140.612 111.422 140.439 110.875 140.252C109.795 139.892 108.982 139.425 108.435 138.852C107.902 138.279 107.635 137.525 107.635 136.592C107.622 135.805 107.802 135.119 108.175 134.532C108.562 133.945 109.095 133.492 109.775 133.172C110.469 132.839 111.275 132.672 112.195 132.672C113.102 132.672 113.895 132.839 114.575 133.172C115.269 133.505 115.809 133.972 116.195 134.572C116.582 135.159 116.782 135.845 116.795 136.632H114.555C114.555 136.272 114.462 135.932 114.275 135.612C114.089 135.279 113.815 135.005 113.455 134.792C113.095 134.579 112.655 134.472 112.135 134.472C111.469 134.459 110.915 134.625 110.475 134.972C110.049 135.319 109.835 135.799 109.835 136.412C109.835 136.959 109.995 137.379 110.315 137.672C110.635 137.965 111.075 138.212 111.635 138.412C112.195 138.599 112.835 138.819 113.555 139.072C114.249 139.299 114.869 139.572 115.415 139.892C115.962 140.212 116.395 140.632 116.715 141.152C117.049 141.672 117.215 142.332 117.215 143.132C117.215 143.839 117.035 144.499 116.675 145.112C116.315 145.712 115.775 146.205 115.055 146.592C114.335 146.965 113.449 147.152 112.395 147.152ZM122.559 146.912V134.632H118.419V132.912H128.799V134.632H124.679V146.912H122.559ZM130.783 146.912V132.912H139.683V134.632H132.903V138.992H139.083V140.672H132.903V145.192H139.683V146.912H130.783ZM142.209 146.912V132.912H147.109C148.202 132.912 149.109 133.099 149.829 133.472C150.549 133.832 151.082 134.332 151.429 134.972C151.789 135.599 151.969 136.312 151.969 137.112C151.969 137.872 151.796 138.572 151.449 139.212C151.116 139.839 150.589 140.339 149.869 140.712C149.149 141.085 148.229 141.272 147.109 141.272H144.329V146.912H142.209ZM144.329 139.532H147.009C148.009 139.532 148.722 139.319 149.149 138.892C149.589 138.452 149.809 137.859 149.809 137.112C149.809 136.339 149.589 135.739 149.149 135.312C148.722 134.872 148.009 134.652 147.009 134.652H144.329V139.532Z"
                  fill="#222528"
                />
                <defs>
                  <filter
                    id="filter0_d_318_1894"
                    x="49.5"
                    y="44.5"
                    width="160"
                    height="160"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_318_1894"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_318_1894"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>

              <h3>
                Browse
                <br />
                Plans
              </h3>
              {/* <p className="mb-lg-0 mb-md-3">
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
              </p> */}
            </Col>
            <Col lg={2} md={6}>
              <svg width="249" height="240" viewBox="0 0 249 240" fill="none">
                <circle
                  cx="129"
                  cy="120"
                  r="118.5"
                  fill="#FEFDFD"
                  stroke="#056AEC"
                  stroke-width="3"
                />
                <circle cx="129" cy="120" r="104" fill="#F7CE46" />
                <g filter="url(#filter0_d_318_1895)">
                  <circle cx="129" cy="120" r="76" fill="#FEFDFD" />
                </g>
                <circle
                  cx="10.5"
                  cy="119.5"
                  r="9"
                  fill="#FEFDFD"
                  stroke="#056AEC"
                  stroke-width="3"
                />
                <path
                  d="M121.54 124.94C118.695 124.94 116.26 124.28 114.236 122.96C112.212 121.611 110.643 119.748 109.528 117.372C108.443 114.967 107.9 112.18 107.9 109.012C107.9 105.873 108.443 103.101 109.528 100.696C110.643 98.2905 112.212 96.4279 114.236 95.1079C116.26 93.7585 118.695 93.0839 121.54 93.0839C124.385 93.0839 126.82 93.7585 128.844 95.1079C130.868 96.4279 132.423 98.2905 133.508 100.696C134.623 103.101 135.18 105.873 135.18 109.012C135.18 112.18 134.623 114.967 133.508 117.372C132.423 119.748 130.868 121.611 128.844 122.96C126.82 124.28 124.385 124.94 121.54 124.94ZM121.54 119.88C123.857 119.88 125.749 118.912 127.216 116.976C128.683 115.04 129.416 112.385 129.416 109.012C129.416 105.639 128.683 102.984 127.216 101.048C125.749 99.1119 123.857 98.1439 121.54 98.1439C119.193 98.1439 117.287 99.1119 115.82 101.048C114.383 102.984 113.664 105.639 113.664 109.012C113.664 112.385 114.383 115.04 115.82 116.976C117.287 118.912 119.193 119.88 121.54 119.88ZM139.187 124.412V120.32C141.065 118.765 142.883 117.225 144.643 115.7C146.433 114.175 148.017 112.664 149.395 111.168C150.803 109.672 151.918 108.22 152.739 106.812C153.59 105.375 154.015 103.981 154.015 102.632C154.015 101.371 153.663 100.256 152.959 99.2879C152.285 98.3199 151.155 97.8359 149.571 97.8359C147.958 97.8359 146.741 98.3639 145.919 99.4199C145.098 100.476 144.687 101.752 144.687 103.248H139.231C139.29 100.989 139.789 99.1119 140.727 97.6159C141.666 96.0905 142.913 94.9612 144.467 94.2279C146.022 93.4652 147.767 93.0839 149.703 93.0839C152.842 93.0839 155.277 93.9492 157.007 95.6799C158.767 97.3812 159.647 99.5959 159.647 102.324C159.647 104.025 159.251 105.683 158.459 107.296C157.697 108.909 156.685 110.464 155.423 111.96C154.162 113.456 152.798 114.864 151.331 116.184C149.865 117.475 148.442 118.677 147.063 119.792H160.395V124.412H139.187Z"
                  fill="#222528"
                />
                <path
                  d="M116.895 146.652C115.869 146.652 114.969 146.472 114.195 146.112C113.422 145.752 112.815 145.239 112.375 144.572C111.949 143.905 111.729 143.112 111.715 142.192H113.955C113.969 142.939 114.229 143.572 114.735 144.092C115.242 144.612 115.955 144.872 116.875 144.872C117.689 144.872 118.322 144.679 118.775 144.292C119.242 143.892 119.475 143.385 119.475 142.772C119.475 142.279 119.362 141.879 119.135 141.572C118.922 141.265 118.622 141.012 118.235 140.812C117.862 140.612 117.429 140.432 116.935 140.272C116.442 140.112 115.922 139.939 115.375 139.752C114.295 139.392 113.482 138.925 112.935 138.352C112.402 137.779 112.135 137.025 112.135 136.092C112.122 135.305 112.302 134.619 112.675 134.032C113.062 133.445 113.595 132.992 114.275 132.672C114.969 132.339 115.775 132.172 116.695 132.172C117.602 132.172 118.395 132.339 119.075 132.672C119.769 133.005 120.309 133.472 120.695 134.072C121.082 134.659 121.282 135.345 121.295 136.132H119.055C119.055 135.772 118.962 135.432 118.775 135.112C118.589 134.779 118.315 134.505 117.955 134.292C117.595 134.079 117.155 133.972 116.635 133.972C115.969 133.959 115.415 134.125 114.975 134.472C114.549 134.819 114.335 135.299 114.335 135.912C114.335 136.459 114.495 136.879 114.815 137.172C115.135 137.465 115.575 137.712 116.135 137.912C116.695 138.099 117.335 138.319 118.055 138.572C118.749 138.799 119.369 139.072 119.915 139.392C120.462 139.712 120.895 140.132 121.215 140.652C121.549 141.172 121.715 141.832 121.715 142.632C121.715 143.339 121.535 143.999 121.175 144.612C120.815 145.212 120.275 145.705 119.555 146.092C118.835 146.465 117.949 146.652 116.895 146.652ZM127.059 146.412V134.132H122.919V132.412H133.299V134.132H129.179V146.412H127.059ZM135.283 146.412V132.412H144.183V134.132H137.403V138.492H143.583V140.172H137.403V144.692H144.183V146.412H135.283ZM146.709 146.412V132.412H151.609C152.702 132.412 153.609 132.599 154.329 132.972C155.049 133.332 155.582 133.832 155.929 134.472C156.289 135.099 156.469 135.812 156.469 136.612C156.469 137.372 156.296 138.072 155.949 138.712C155.616 139.339 155.089 139.839 154.369 140.212C153.649 140.585 152.729 140.772 151.609 140.772H148.829V146.412H146.709ZM148.829 139.032H151.509C152.509 139.032 153.222 138.819 153.649 138.392C154.089 137.952 154.309 137.359 154.309 136.612C154.309 135.839 154.089 135.239 153.649 134.812C153.222 134.372 152.509 134.152 151.509 134.152H148.829V139.032Z"
                  fill="#222528"
                />
                <defs>
                  <filter
                    id="filter0_d_318_1895"
                    x="49"
                    y="44"
                    width="160"
                    height="160"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_318_1895"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_318_1895"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>

              <h3>
                Fill Business
                <br />
                Details
              </h3>
              {/* <p className="mb-lg-0 mb-md-3">
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
              </p> */}
            </Col>
            <Col lg={2} md={6}>
              <svg width="249" height="240" viewBox="0 0 249 240" fill="none">
                <circle
                  cx="129"
                  cy="120"
                  r="118.5"
                  fill="#FEFDFD"
                  stroke="#056AEC"
                  stroke-width="3"
                />
                <circle cx="129" cy="120" r="104" fill="#F7CE46" />
                <g filter="url(#filter0_d_318_1895)">
                  <circle cx="129" cy="120" r="76" fill="#FEFDFD" />
                </g>
                <circle
                  cx="10.5"
                  cy="119.5"
                  r="9"
                  fill="#FEFDFD"
                  stroke="#056AEC"
                  stroke-width="3"
                />
                <path
                  d="M121.395 124.94C118.55 124.94 116.115 124.28 114.091 122.96C112.067 121.611 110.498 119.748 109.383 117.372C108.298 114.967 107.755 112.18 107.755 109.012C107.755 105.873 108.298 103.101 109.383 100.696C110.498 98.2905 112.067 96.4279 114.091 95.1079C116.115 93.7585 118.55 93.0839 121.395 93.0839C124.241 93.0839 126.675 93.7585 128.699 95.1079C130.723 96.4279 132.278 98.2905 133.363 100.696C134.478 103.101 135.035 105.873 135.035 109.012C135.035 112.18 134.478 114.967 133.363 117.372C132.278 119.748 130.723 121.611 128.699 122.96C126.675 124.28 124.241 124.94 121.395 124.94ZM121.395 119.88C123.713 119.88 125.605 118.912 127.071 116.976C128.538 115.04 129.271 112.385 129.271 109.012C129.271 105.639 128.538 102.984 127.071 101.048C125.605 99.1119 123.713 98.1439 121.395 98.1439C119.049 98.1439 117.142 99.1119 115.675 101.048C114.238 102.984 113.519 105.639 113.519 109.012C113.519 112.385 114.238 115.04 115.675 116.976C117.142 118.912 119.049 119.88 121.395 119.88ZM150.082 124.94C148.058 124.94 146.224 124.588 144.582 123.884C142.939 123.151 141.619 122.036 140.622 120.54C139.624 119.044 139.096 117.167 139.038 114.908H144.582C144.611 116.404 145.095 117.665 146.034 118.692C147.002 119.689 148.351 120.188 150.082 120.188C151.724 120.188 152.986 119.733 153.866 118.824C154.746 117.915 155.186 116.771 155.186 115.392C155.186 113.779 154.599 112.561 153.426 111.74C152.282 110.889 150.8 110.464 148.982 110.464H146.694V105.844H149.026C150.522 105.844 151.768 105.492 152.766 104.788C153.763 104.084 154.262 103.043 154.262 101.664C154.262 100.52 153.88 99.6105 153.118 98.9359C152.384 98.2319 151.358 97.8799 150.038 97.8799C148.6 97.8799 147.471 98.3052 146.65 99.1559C145.858 100.007 145.418 101.048 145.33 102.28H139.83C139.947 99.4345 140.93 97.1905 142.778 95.5479C144.655 93.9052 147.075 93.0839 150.038 93.0839C152.15 93.0839 153.924 93.4652 155.362 94.2279C156.828 94.9612 157.928 95.9439 158.662 97.1759C159.424 98.4079 159.806 99.7719 159.806 101.268C159.806 102.999 159.322 104.465 158.354 105.668C157.415 106.841 156.242 107.633 154.834 108.044C156.564 108.396 157.972 109.247 159.058 110.596C160.143 111.916 160.686 113.588 160.686 115.612C160.686 117.313 160.275 118.868 159.454 120.276C158.632 121.684 157.43 122.813 155.846 123.664C154.291 124.515 152.37 124.94 150.082 124.94Z"
                  fill="#222528"
                />
                <path
                  d="M117.395 146.652C116.369 146.652 115.469 146.472 114.695 146.112C113.922 145.752 113.315 145.239 112.875 144.572C112.449 143.905 112.229 143.112 112.215 142.192H114.455C114.469 142.939 114.729 143.572 115.235 144.092C115.742 144.612 116.455 144.872 117.375 144.872C118.189 144.872 118.822 144.679 119.275 144.292C119.742 143.892 119.975 143.385 119.975 142.772C119.975 142.279 119.862 141.879 119.635 141.572C119.422 141.265 119.122 141.012 118.735 140.812C118.362 140.612 117.929 140.432 117.435 140.272C116.942 140.112 116.422 139.939 115.875 139.752C114.795 139.392 113.982 138.925 113.435 138.352C112.902 137.779 112.635 137.025 112.635 136.092C112.622 135.305 112.802 134.619 113.175 134.032C113.562 133.445 114.095 132.992 114.775 132.672C115.469 132.339 116.275 132.172 117.195 132.172C118.102 132.172 118.895 132.339 119.575 132.672C120.269 133.005 120.809 133.472 121.195 134.072C121.582 134.659 121.782 135.345 121.795 136.132H119.555C119.555 135.772 119.462 135.432 119.275 135.112C119.089 134.779 118.815 134.505 118.455 134.292C118.095 134.079 117.655 133.972 117.135 133.972C116.469 133.959 115.915 134.125 115.475 134.472C115.049 134.819 114.835 135.299 114.835 135.912C114.835 136.459 114.995 136.879 115.315 137.172C115.635 137.465 116.075 137.712 116.635 137.912C117.195 138.099 117.835 138.319 118.555 138.572C119.249 138.799 119.869 139.072 120.415 139.392C120.962 139.712 121.395 140.132 121.715 140.652C122.049 141.172 122.215 141.832 122.215 142.632C122.215 143.339 122.035 143.999 121.675 144.612C121.315 145.212 120.775 145.705 120.055 146.092C119.335 146.465 118.449 146.652 117.395 146.652ZM127.559 146.412V134.132H123.419V132.412H133.799V134.132H129.679V146.412H127.559ZM135.783 146.412V132.412H144.683V134.132H137.903V138.492H144.083V140.172H137.903V144.692H144.683V146.412H135.783ZM147.209 146.412V132.412H152.109C153.202 132.412 154.109 132.599 154.829 132.972C155.549 133.332 156.082 133.832 156.429 134.472C156.789 135.099 156.969 135.812 156.969 136.612C156.969 137.372 156.796 138.072 156.449 138.712C156.116 139.339 155.589 139.839 154.869 140.212C154.149 140.585 153.229 140.772 152.109 140.772H149.329V146.412H147.209ZM149.329 139.032H152.009C153.009 139.032 153.722 138.819 154.149 138.392C154.589 137.952 154.809 137.359 154.809 136.612C154.809 135.839 154.589 135.239 154.149 134.812C153.722 134.372 153.009 134.152 152.009 134.152H149.329V139.032Z"
                  fill="#222528"
                />
                <defs>
                  <filter
                    id="filter0_d_318_1895"
                    x="49"
                    y="44"
                    width="160"
                    height="160"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_318_1895"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_318_1895"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>

              <h3>
                Setup
                <br />
                Application
              </h3>
              {/* <p className="mb-lg-0 mb-md-3">
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
              </p> */}
            </Col>
            <Col lg={2} md={6}>
              <svg width="249" height="240" viewBox="0 0 249 240" fill="none">
                <circle
                  cx="129"
                  cy="120"
                  r="118.5"
                  fill="#FEFDFD"
                  stroke="#056AEC"
                  stroke-width="3"
                />
                <circle cx="129" cy="120" r="104" fill="#F7CE46" />
                <g filter="url(#filter0_d_318_1895)">
                  <circle cx="129" cy="120" r="76" fill="#FEFDFD" />
                </g>
                <circle
                  cx="10.5"
                  cy="119.5"
                  r="9"
                  fill="#FEFDFD"
                  stroke="#056AEC"
                  stroke-width="3"
                />
                <path
                  d="M121.407 124.94C118.562 124.94 116.127 124.28 114.103 122.96C112.079 121.611 110.51 119.748 109.395 117.372C108.31 114.967 107.767 112.18 107.767 109.012C107.767 105.873 108.31 103.101 109.395 100.696C110.51 98.2905 112.079 96.4279 114.103 95.1079C116.127 93.7585 118.562 93.0839 121.407 93.0839C124.252 93.0839 126.687 93.7585 128.711 95.1079C130.735 96.4279 132.29 98.2905 133.375 100.696C134.49 103.101 135.047 105.873 135.047 109.012C135.047 112.18 134.49 114.967 133.375 117.372C132.29 119.748 130.735 121.611 128.711 122.96C126.687 124.28 124.252 124.94 121.407 124.94ZM121.407 119.88C123.724 119.88 125.616 118.912 127.083 116.976C128.55 115.04 129.283 112.385 129.283 109.012C129.283 105.639 128.55 102.984 127.083 101.048C125.616 99.1119 123.724 98.1439 121.407 98.1439C119.06 98.1439 117.154 99.1119 115.687 101.048C114.25 102.984 113.531 105.639 113.531 109.012C113.531 112.385 114.25 115.04 115.687 116.976C117.154 118.912 119.06 119.88 121.407 119.88ZM154.097 124.412V118.692H138.917V114.204L153.349 93.6119H159.729V113.808H163.777V118.692H159.729V124.412H154.097ZM144.945 113.808H154.449V99.8159L144.945 113.808Z"
                  fill="#222528"
                />
                <path
                  d="M118.395 146.652C117.369 146.652 116.469 146.472 115.695 146.112C114.922 145.752 114.315 145.239 113.875 144.572C113.449 143.905 113.229 143.112 113.215 142.192H115.455C115.469 142.939 115.729 143.572 116.235 144.092C116.742 144.612 117.455 144.872 118.375 144.872C119.189 144.872 119.822 144.679 120.275 144.292C120.742 143.892 120.975 143.385 120.975 142.772C120.975 142.279 120.862 141.879 120.635 141.572C120.422 141.265 120.122 141.012 119.735 140.812C119.362 140.612 118.929 140.432 118.435 140.272C117.942 140.112 117.422 139.939 116.875 139.752C115.795 139.392 114.982 138.925 114.435 138.352C113.902 137.779 113.635 137.025 113.635 136.092C113.622 135.305 113.802 134.619 114.175 134.032C114.562 133.445 115.095 132.992 115.775 132.672C116.469 132.339 117.275 132.172 118.195 132.172C119.102 132.172 119.895 132.339 120.575 132.672C121.269 133.005 121.809 133.472 122.195 134.072C122.582 134.659 122.782 135.345 122.795 136.132H120.555C120.555 135.772 120.462 135.432 120.275 135.112C120.089 134.779 119.815 134.505 119.455 134.292C119.095 134.079 118.655 133.972 118.135 133.972C117.469 133.959 116.915 134.125 116.475 134.472C116.049 134.819 115.835 135.299 115.835 135.912C115.835 136.459 115.995 136.879 116.315 137.172C116.635 137.465 117.075 137.712 117.635 137.912C118.195 138.099 118.835 138.319 119.555 138.572C120.249 138.799 120.869 139.072 121.415 139.392C121.962 139.712 122.395 140.132 122.715 140.652C123.049 141.172 123.215 141.832 123.215 142.632C123.215 143.339 123.035 143.999 122.675 144.612C122.315 145.212 121.775 145.705 121.055 146.092C120.335 146.465 119.449 146.652 118.395 146.652ZM128.559 146.412V134.132H124.419V132.412H134.799V134.132H130.679V146.412H128.559ZM136.783 146.412V132.412H145.683V134.132H138.903V138.492H145.083V140.172H138.903V144.692H145.683V146.412H136.783ZM148.209 146.412V132.412H153.109C154.202 132.412 155.109 132.599 155.829 132.972C156.549 133.332 157.082 133.832 157.429 134.472C157.789 135.099 157.969 135.812 157.969 136.612C157.969 137.372 157.796 138.072 157.449 138.712C157.116 139.339 156.589 139.839 155.869 140.212C155.149 140.585 154.229 140.772 153.109 140.772H150.329V146.412H148.209ZM150.329 139.032H153.009C154.009 139.032 154.722 138.819 155.149 138.392C155.589 137.952 155.809 137.359 155.809 136.612C155.809 135.839 155.589 135.239 155.149 134.812C154.722 134.372 154.009 134.152 153.009 134.152H150.329V139.032Z"
                  fill="#222528"
                />
                <defs>
                  <filter
                    id="filter0_d_318_1895"
                    x="49"
                    y="44"
                    width="160"
                    height="160"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_318_1895"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_318_1895"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>

              <h3>
                Start Adding
                <br />
                Screenings
              </h3>
              {/* <p className="mb-lg-0 mb-md-3">
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
              </p> */}
            </Col>
            <Col lg={2} md={6}>
              <svg width="249" height="240" viewBox="0 0 249 240" fill="none">
                <circle
                  cx="129"
                  cy="120"
                  r="118.5"
                  fill="#FEFDFD"
                  stroke="#056AEC"
                  stroke-width="3"
                />
                <circle cx="129" cy="120" r="104" fill="#F7CE46" />
                <g filter="url(#filter0_d_318_1895)">
                  <circle cx="129" cy="120" r="76" fill="#FEFDFD" />
                </g>
                <circle
                  cx="10.5"
                  cy="119.5"
                  r="9"
                  fill="#FEFDFD"
                  stroke="#056AEC"
                  stroke-width="3"
                />
                <path
                  d="M115.312 124.94C112.526 124.94 110.12 124.265 108.096 122.916C106.072 121.567 104.518 119.704 103.432 117.328C102.376 114.923 101.848 112.151 101.848 109.012C101.848 105.873 102.376 103.116 103.432 100.74C104.518 98.3345 106.058 96.4572 108.052 95.1079C110.076 93.7585 112.496 93.0839 115.312 93.0839C118.128 93.0839 120.534 93.7585 122.528 95.1079C124.552 96.4572 126.092 98.3345 127.148 100.74C128.234 103.116 128.776 105.873 128.776 109.012C128.776 112.151 128.234 114.923 127.148 117.328C126.092 119.704 124.552 121.567 122.528 122.916C120.534 124.265 118.128 124.94 115.312 124.94ZM115.312 119.616C116.779 119.616 118.07 119.191 119.184 118.34C120.299 117.46 121.164 116.228 121.78 114.644C122.426 113.06 122.748 111.183 122.748 109.012C122.748 106.812 122.426 104.935 121.78 103.38C121.164 101.796 120.299 100.579 119.184 99.7279C118.07 98.8772 116.779 98.4519 115.312 98.4519C113.846 98.4519 112.555 98.8772 111.44 99.7279C110.326 100.579 109.446 101.796 108.8 103.38C108.184 104.935 107.876 106.812 107.876 109.012C107.876 111.183 108.184 113.06 108.8 114.644C109.446 116.228 110.326 117.46 111.44 118.34C112.555 119.191 113.846 119.616 115.312 119.616ZM144.841 124.94C142.611 124.94 140.675 124.544 139.033 123.752C137.419 122.96 136.158 121.875 135.249 120.496C134.339 119.117 133.811 117.548 133.665 115.788H139.473C139.678 116.932 140.265 117.9 141.233 118.692C142.201 119.484 143.418 119.88 144.885 119.88C145.941 119.88 146.865 119.616 147.657 119.088C148.449 118.56 149.065 117.856 149.505 116.976C149.945 116.067 150.165 115.04 150.165 113.896C150.165 112.723 149.93 111.711 149.461 110.86C149.021 110.009 148.405 109.349 147.613 108.88C146.85 108.411 145.97 108.176 144.973 108.176C143.711 108.176 142.626 108.484 141.717 109.1C140.837 109.687 140.206 110.405 139.825 111.256H134.061L136.613 93.6119H153.905V98.8039H141.013L139.737 105.668C140.382 104.993 141.247 104.436 142.333 103.996C143.418 103.556 144.635 103.336 145.985 103.336C147.657 103.336 149.109 103.629 150.341 104.216C151.573 104.803 152.599 105.595 153.421 106.592C154.242 107.56 154.858 108.675 155.269 109.936C155.679 111.168 155.885 112.473 155.885 113.852C155.885 115.465 155.606 116.947 155.049 118.296C154.521 119.645 153.758 120.819 152.761 121.816C151.793 122.813 150.634 123.591 149.285 124.148C147.965 124.676 146.483 124.94 144.841 124.94Z"
                  fill="#222528"
                />
                <path
                  d="M118.395 146.652C117.369 146.652 116.469 146.472 115.695 146.112C114.922 145.752 114.315 145.239 113.875 144.572C113.449 143.905 113.229 143.112 113.215 142.192H115.455C115.469 142.939 115.729 143.572 116.235 144.092C116.742 144.612 117.455 144.872 118.375 144.872C119.189 144.872 119.822 144.679 120.275 144.292C120.742 143.892 120.975 143.385 120.975 142.772C120.975 142.279 120.862 141.879 120.635 141.572C120.422 141.265 120.122 141.012 119.735 140.812C119.362 140.612 118.929 140.432 118.435 140.272C117.942 140.112 117.422 139.939 116.875 139.752C115.795 139.392 114.982 138.925 114.435 138.352C113.902 137.779 113.635 137.025 113.635 136.092C113.622 135.305 113.802 134.619 114.175 134.032C114.562 133.445 115.095 132.992 115.775 132.672C116.469 132.339 117.275 132.172 118.195 132.172C119.102 132.172 119.895 132.339 120.575 132.672C121.269 133.005 121.809 133.472 122.195 134.072C122.582 134.659 122.782 135.345 122.795 136.132H120.555C120.555 135.772 120.462 135.432 120.275 135.112C120.089 134.779 119.815 134.505 119.455 134.292C119.095 134.079 118.655 133.972 118.135 133.972C117.469 133.959 116.915 134.125 116.475 134.472C116.049 134.819 115.835 135.299 115.835 135.912C115.835 136.459 115.995 136.879 116.315 137.172C116.635 137.465 117.075 137.712 117.635 137.912C118.195 138.099 118.835 138.319 119.555 138.572C120.249 138.799 120.869 139.072 121.415 139.392C121.962 139.712 122.395 140.132 122.715 140.652C123.049 141.172 123.215 141.832 123.215 142.632C123.215 143.339 123.035 143.999 122.675 144.612C122.315 145.212 121.775 145.705 121.055 146.092C120.335 146.465 119.449 146.652 118.395 146.652ZM128.559 146.412V134.132H124.419V132.412H134.799V134.132H130.679V146.412H128.559ZM136.783 146.412V132.412H145.683V134.132H138.903V138.492H145.083V140.172H138.903V144.692H145.683V146.412H136.783ZM148.209 146.412V132.412H153.109C154.202 132.412 155.109 132.599 155.829 132.972C156.549 133.332 157.082 133.832 157.429 134.472C157.789 135.099 157.969 135.812 157.969 136.612C157.969 137.372 157.796 138.072 157.449 138.712C157.116 139.339 156.589 139.839 155.869 140.212C155.149 140.585 154.229 140.772 153.109 140.772H150.329V146.412H148.209ZM150.329 139.032H153.009C154.009 139.032 154.722 138.819 155.149 138.392C155.589 137.952 155.809 137.359 155.809 136.612C155.809 135.839 155.589 135.239 155.149 134.812C154.722 134.372 154.009 134.152 153.009 134.152H150.329V139.032Z"
                  fill="#222528"
                />
                <defs>
                  <filter
                    id="filter0_d_318_1895"
                    x="49"
                    y="44"
                    width="160"
                    height="160"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_318_1895"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_318_1895"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>

              <h3>
                Check Risks and
                <br />
                Modify
              </h3>
              {/* <p className="mb-lg-0 mb-md-3">
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
              </p> */}
            </Col>
          </Row>
        </Container>
      </section>
      <section className="pt-5 pb-5 plan_sec">
        <Container fluid className="widthSmall">
          <h2 className="light_heading text-center">Plans</h2>
          <Row className="mb-lg-4 mb-md-4 mb-3">
            <Col>
              <div className="radio_box">
                <div className="border_b">
                  <label>
                    <input
                      type="radio"
                      name="product"
                      className="card-input-element"
                      checked
                      onClick={() => setcheckuser("monthly")}
                    />
                    <div className="panel panel-default card-input">
                      <div className="panel-heading">Monthly</div>
                    </div>
                  </label>

                  <label>
                    <input
                      type="radio"
                      name="product"
                      className="card-input-element"
                      onClick={() => setcheckuser("year")}
                    />

                    <div className="panel panel-default card-input">
                      <div className="panel-heading">
                        Yearly <Badge>Save 20%</Badge>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="plan_box flex-row">
                {checkuser == "monthly" && (
                  <>
                    {paymentData.map((item, index) => {
                      console.log("🚀 ~ {paymentData.map ~ item:", item)
                      if (item.recurring.interval === "month") {
                        // dataToPass.prize = (item.unit_amount / 100).toString();

                        return (
                          <>
                            <Card className="borderPrimary w25" key={index}>
                              <Card.Body>
                                <div className="side_badge side_badge_primary">
                                  <h6 className="basicH6">
                                    {item.productDetails.name}
                                  </h6>
                                </div>
                                <h2>
                                  {`$${(item.unit_amount / 100).toString()} `}{" "}
                                  <span>per month</span>
                                </h2>
                                <h2>Benefits</h2>
                                <div
                                  className="col-md-12"
                                  dangerouslySetInnerHTML={{
                                    __html: item.productDetails.description,
                                  }}
                                ></div>

                                {/* <div className="mediaBox">
                                  <Image src={PlanIcon1} alt="" />
                                  <div>
                                    <h3>5 Requests Daily</h3>
                                    <p>Lorem ipsum dolor sit amet</p>
                                  </div>
                                </div>

                                <div className="mediaBox">
                                  <Image src={PlanIcon2} alt="" />
                                  <div>
                                    <h3>Customer Support</h3>
                                    <p>Lorem ipsum dolor sit amet</p>
                                  </div>
                                </div>

                                <div className="mediaBox">
                                  <Image src={PlanIcon3} alt="" />
                                  <div>
                                    <h3>Easy Management</h3>
                                    <p>Lorem ipsum dolor sit amet</p>
                                  </div>
                                </div>

                                <div className="mediaBox">
                                  <Image src={PlanIcon4} alt="" />
                                  <div>
                                    <h3>1 User</h3>
                                    <p>
                                      Lorem ipsum dolor sit amet consectetur.
                                    </p>
                                  </div>
                                </div> */}
                                <Link
                                   to={{
                                    pathname: "/sign-up",
                                    state: {
                                      fromDashboard: true,
                                      prize: "19",
                                    },
                                  }}
                                  className="btn btn-primary btn-yellow"
                                  onClick={() =>
                                    handleGetStartedClick(
                                      (item.unit_amount / 100).toString(),
                                      item.productDetails.name,
                                      item.recurring.interval,
                                      item.product,
                                    )
                                  }
                                >
                                  Get Started <Image src={ArrowRight} alt="" />
                                </Link>
                              </Card.Body>
                            </Card>

                            {/* <Card className="borderPro w30">
                              <Card.Body>
                                <div className="side_badge">
                                  <h6 className="proH6">PROFESSIONAL</h6>
                                </div>
                                <h2>
                                  49$ <span>per month</span>
                                </h2>
                                <div className="mediaBox">
                                  <Image src={PlanIcon1} alt="" />
                                  <div>
                                    <h3>15 Requests Daily</h3>
                                    <p>
                                      Lorem ipsum dolor sit amet consectetur. Ut
                                      sed at magna a bibendum sit
                                    </p>
                                  </div>
                                </div>

                                <div className="mediaBox">
                                  <Image src={PlanIcon2} alt="" />
                                  <div>
                                    <h3>Instant Customer Support</h3>
                                    <p>
                                      Lorem ipsum dolor sit amet consectetur. Ut
                                      sed at magna a bibendum sit
                                    </p>
                                  </div>
                                </div>

                                <div className="mediaBox">
                                  <Image src={PlanIcon3} alt="" />
                                  <div>
                                    <h3>Easy Management</h3>
                                    <p>
                                      Lorem ipsum dolor sit amet consectetur. Ut
                                      sed at magna a bibendum sit
                                    </p>
                                  </div>
                                </div>

                                <div className="mediaBox">
                                  <Image src={PlanIcon4} alt="" />
                                  <div>
                                    <h3>Upto 5 Users</h3>
                                    <p>
                                      Lorem ipsum dolor sit amet consectetur.
                                    </p>
                                  </div>
                                </div>

                                <Link
                                  to="/sign-up"
                                  className="btn btn-primary btn-yellow"
                                  onClick={handleGetStartedClick1}
                                >
                                  Get Started <Image src={ArrowRight} alt="" />
                                </Link>
                              </Card.Body>
                            </Card> */}
                          </>
                        );

                        // Assuming unit_amount is in cents
                      }
                    })}
                  </>
                )}
                {checkuser == "year" && (
                  <>
                    {paymentData.map((item, index) => {
                      if (item.recurring.interval === "year") {
                        return (
                          <Card className="borderAdvance w30" key={index}>
                            <Card.Body>
                              <div className="side_badge">
                                <h6 className="advanceH6">
                                 
                                  {item.productDetails.name}
                                </h6>
                              </div>
                              <h2 className="advnce">
                                {`$${(item.unit_amount / 100).toString()}`}{" "}
                                <span>per year</span>
                              </h2>
                              <h2>Benefits</h2>

                              <div
                                className="col-md-12"
                                dangerouslySetInnerHTML={{
                                  __html: item.productDetails.description,
                                }}
                              ></div>
                              <Link
                                   to={{
                                    pathname: "/sign-up",
                                    state: {
                                      fromDashboard: true,
                                      prize: "19",
                                    },
                                  }}
                                  className="btn btn-primary btn-yellow"
                                  onClick={() =>
                                    handleGetStartedClick(
                                      (item.unit_amount / 100).toString(),
                                      item.productDetails.name,
                                      item.recurring.interval,
                                      item.product,
                                    )
                                  }
                                >
                                  Get Started <Image src={ArrowRight} alt="" />
                                </Link>
                            </Card.Body>
                          </Card>
                        );
                      }
                    })}
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* <section className="pt-3 pb-5 plan_sec">
        <Container fluid className="widthSmall">
          <h2 className="light_heading text-center">Plans</h2>
          <Row className="mb-lg-4 mb-md-4 mb-3">
            <Col>
              <div className="radio_box">
                <div className="border_b">
                  <label>
                    <input
                      type="radio"
                      name="product"
                      className="card-input-element"
                      checked
                    />
                    <div className="panel panel-default card-input">
                      <div className="panel-heading">Monthly</div>
                    </div>
                  </label>

                  <label>
                    <input
                      type="radio"
                      name="product"
                      className="card-input-element"
                    />

                    <div className="panel panel-default card-input">
                      <div className="panel-heading">
                        Yearly <Badge>Save 20%</Badge>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="plan_box flex-row">
                <Card className="borderPrimary w25">
                  <Card.Body>
                    <div className="side_badge side_badge_primary">
                      <h6 className="basicH6">BASIC</h6>
                    </div>
                    <h2>
                      19$ <span>per month</span>
                    </h2>
                    <div className="mediaBox">
                      <Image src={PlanIcon1} alt="" />
                      <div>
                        <h3>5 Requests Daily</h3>
                        <p>Lorem ipsum dolor sit amet</p>
                      </div>
                    </div>

                    <div className="mediaBox">
                      <Image src={PlanIcon2} alt="" />
                      <div>
                        <h3>Customer Support</h3>
                        <p>Lorem ipsum dolor sit amet</p>
                      </div>
                    </div>

                    <div className="mediaBox">
                      <Image src={PlanIcon3} alt="" />
                      <div>
                        <h3>Easy Management</h3>
                        <p>Lorem ipsum dolor sit amet</p>
                      </div>
                    </div>

                    <div className="mediaBox">
                      <Image src={PlanIcon4} alt="" />
                      <div>
                        <h3>1 User</h3>
                        <p>Lorem ipsum dolor sit amet consectetur.</p>
                      </div>
                    </div>

                    <Button className="btn btn-primary btn-yellow">
                      Get Started <Image src={ArrowRight} alt="" />
                    </Button>
                  </Card.Body>
                </Card>
                <Card className="borderPro w30">
                  <Card.Body>
                    <div className="side_badge">
                      <h6 className="proH6">PROFESSIONAL</h6>
                    </div>
                    <h2>
                      49$ <span>per month</span>
                    </h2>
                    <div className="mediaBox">
                      <Image src={PlanIcon1} alt="" />
                      <div>
                        <h3>15 Requests Daily</h3>
                        <p>
                          Lorem ipsum dolor sit amet consectetur. Ut sed at
                          magna a bibendum sit
                        </p>
                      </div>
                    </div>

                    <div className="mediaBox">
                      <Image src={PlanIcon2} alt="" />
                      <div>
                        <h3>Instant Customer Support</h3>
                        <p>
                          Lorem ipsum dolor sit amet consectetur. Ut sed at
                          magna a bibendum sit
                        </p>
                      </div>
                    </div>

                    <div className="mediaBox">
                      <Image src={PlanIcon3} alt="" />
                      <div>
                        <h3>Easy Management</h3>
                        <p>
                          Lorem ipsum dolor sit amet consectetur. Ut sed at
                          magna a bibendum sit
                        </p>
                      </div>
                    </div>

                    <div className="mediaBox">
                      <Image src={PlanIcon4} alt="" />
                      <div>
                        <h3>Upto 5 Users</h3>
                        <p>Lorem ipsum dolor sit amet consectetur.</p>
                      </div>
                    </div>

                    <Button className="btn btn-primary btn-yellow">
                      Get Started <Image src={ArrowRight} alt="" />
                    </Button>
                  </Card.Body>
                </Card>
                <Card className="borderAdvance w30">
                  <Card.Body>
                    <div className="side_badge">
                      <h6 className="advanceH6">ADVANCE</h6>
                    </div>
                    <h2 className="advnce">
                      99$ <span>per month</span>
                    </h2>
                    <div className="mediaBox">
                      <Image src={PlanIcon1} alt="" />
                      <div>
                        <h3>30 Requests Daily</h3>
                        <p>
                          Lorem ipsum dolor sit amet consectetur. Ut sed at
                          magna a bibendum sit
                        </p>
                      </div>
                    </div>

                    <div className="mediaBox">
                      <Image src={PlanIcon2} alt="" />
                      <div>
                        <h3>Instant Customer Support</h3>
                        <p>
                          Lorem ipsum dolor sit amet consectetur. Ut sed at
                          magna a bibendum sit
                        </p>
                      </div>
                    </div>

                    <div className="mediaBox">
                      <Image src={PlanIcon3} alt="" />
                      <div>
                        <h3>Easy Management</h3>
                        <p>
                          Lorem ipsum dolor sit amet consectetur. Ut sed at
                          magna a bibendum sit
                        </p>
                      </div>
                    </div>

                    <div className="mediaBox">
                      <Image src={PlanIcon4} alt="" />
                      <div>
                        <h3>Upto 5 Users</h3>
                        <p>Lorem ipsum dolor sit amet consectetur.</p>
                      </div>
                    </div>

                    <Button className="btn btn-primary btn-yellow">
                      Get Started <Image src={ArrowRight} alt="" />
                    </Button>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}

      <OurPartners />
      <div className="text-center mb-4">
        <Button className="btn btn-primary btn-yellow maxWidthAuto">
          Join Now <Image src={ArrowRight} alt="" />
        </Button>
      </div>
{/* 
      <section className="pt-3 pb-5 blog_sec">
        <Container fluid className="widthSmall">
          <h2 className="light_heading text-center mb-5">
            Recent <span>Blogs</span>
          </h2>
          <Row>
            <Col lg={4} md={4}>
              <div className="blog_card">
                <h2>Lorem Ipsum is simply dummy</h2>
                <p>
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s,
                </p>
                <Link>
                  <AiOutlineArrowRight />
                </Link>
              </div>
            </Col>
            <Col lg={4} md={4}>
              <div className="blog_card">
                <h2>Lorem Ipsum is simply dummy</h2>
                <p>
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s,
                </p>
                <Link>
                  <AiOutlineArrowRight />
                </Link>
              </div>
            </Col>
            <Col lg={4} md={4}>
              <div className="blog_card">
                <h2>Lorem Ipsum is simply dummy</h2>
                <p>
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s,
                </p>
                <Link>
                  <AiOutlineArrowRight />
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}
    </>
  );
}
export default Home;
